import React from 'react';

import { useTranslations } from 'next-intl';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import messages from '../messages';
import Button from '@/ui/components/Button';
import { log } from '@/utils/logger';
import request from '@/utils/queryData/rest/clientRequest';
// import { useLocale } from 'next-intl';
// import { usePathname } from 'next/navigation';

export default function ReCaptchaSubmitButton({
  onSubmitAction,
  disabled,
  children,
  setErrors,
}) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const translate = useTranslations();
  // const { t } = usePruslation();

  /**
   * @todo implement reCaptcha check
   * @todo trigger send out formik data
   */
  const handleReCaptchaVerify = React.useCallback(async () => {
    if (!executeRecaptcha) return;

    const token = await executeRecaptcha('FEEDBACK');

    new request(`recaptcha`)
      .post({
        body: {
          token,
        },
      })
      .then(data => {
        if (!data) return null;

        if ('score' in data) {
          if (data?.score > 0.3) {
            return onSubmitAction();
          }
        }
        setErrors({ feedback_error: translate(messages.error) });
      })
      .catch(error => {
        setErrors({ feedback_error: translate(messages.error) });
        log.error(error);
      });
  }, [executeRecaptcha]);

  return (
    <Button onClick={handleReCaptchaVerify} disabled={disabled}>
      {children}
    </Button>
    // <SubmitButton
    //   type="submit"
    //   onClick={onSubmitAction} //handleReCaptchaVerify
    //   disabled={disabled}
    // >
    //   {children}
    // </SubmitButton>
  );
}
